export const DISCIPLINES = ["Gas", "Water", "Elektra", "Warmte", "Riool", "Overig"];

export const ERVARING_OPTIONS: { value: string; label: string }[] = [
  { value: "0 years",   label: "Geen vereiste ervaring" },
  { value: "1-3 years", label: "1-3 jaar" },
  { value: "3-5 years", label: "3-5 jaar" },
  { value: "5+ years",  label: "5+ jaar" },
];

export const PRIORITY_OPTIONS: { value: string; label: string }[] = [
  { value: "laag",    label: "Laag" },
  { value: "normaal", label: "Normaal" },
  { value: "hoog",    label: "Hoog" },
];

export const SALARY_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "range", label: "Salaris range" },
  { value: "fixed", label: "Vast bedrag" },
  { value: "other", label: "Anders" },
];
